/**
 * Sticky add to cart bar on product pages
 */
(function () {
  const form = document.querySelector('[data-product-form]');
  if (!form || !document.querySelector('.template-product')) return;

  const bar = document.createElement('div');
  bar.className = 'sticky-atc hidden';
  bar.innerHTML = `
    <div class="container flex-between" style="padding: 0.75rem 0;">
      <span class="sticky-atc__title"></span>
      <button type="button" class="btn btn--primary btn--sm" data-sticky-atc>Add to cart</button>
    </div>`;
  bar.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:var(--color-background);border-top:1px solid var(--color-border);z-index:200;transform:translateY(100%);transition:transform 300ms ease;';
  document.body.appendChild(bar);

  const title = bar.querySelector('.sticky-atc__title');
  title.textContent = document.querySelector('.product-form__title')?.textContent || '';

  const observer = new IntersectionObserver(([entry]) => {
    bar.style.transform = entry.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
  }, { threshold: 0 });

  const submit = form.querySelector('[type="submit"]');
  if (submit) observer.observe(submit);

  bar.querySelector('[data-sticky-atc]')?.addEventListener('click', () => submit?.click());
})();
